import { render, staticRenderFns } from "./cwmx.vue?vue&type=template&id=0dd60d88&scoped=true&"
import script from "./cwmx.vue?vue&type=script&lang=js&"
export * from "./cwmx.vue?vue&type=script&lang=js&"
import style0 from "./cwmx.vue?vue&type=style&index=0&id=0dd60d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd60d88",
  null
  
)

export default component.exports